import { colors } from 'style'
import styled from 'styled-components'

export const InvitationContainer = styled.div`
  width: 100%;
  padding-left: 16px;
  padding-right: 16px;
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  background: linear-gradient(to right, ${colors.dark8}, ${colors.dark6});
  .signin-wrapper {
    width: 100%;
    height: fit-content;
    max-width: 400px;
    background: white;
    padding: 18px;
    border-radius: 6px;
    h4 {
      color: ${colors.blueDark};
      margin-bottom: 24px;
    }
    input {
      width: 100%;
      padding: 12px;
      border: 1px solid ${colors.border};
      border-radius: 2px;
      margin-bottom: 10px;
    }
    .error {
      color: red;
    }
    .btn {
      width: 100%;
      color: white;
      height: 44px;
      letter-spacing: 1px;
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      box-shadow: 8px 7px 17px -9px rgba(0, 0, 0, 0.41);
      -webkit-box-shadow: 8px 7px 17px -9px rgba(0, 0, 0, 0.41);
      -moz-box-shadow: 8px 7px 17px -9px rgba(0, 0, 0, 0.41);
    }
    .btn-signin {
      margin-top: 10px;
      background: ${colors.blueDark};
      text-transform: uppercase;
    }
    .btn-facebook {
      background: #4267b2;
      margin-bottom: 12px;
      display: flex;
      justify-content: center;
      position: relative;
      i {
        position: absolute;
        left: 18px;
        top: 14px;
      }
    }
    .btn-google {
      background: #4285f4;
      display: flex;
      justify-content: center;
      position: relative;
      i {
        position: absolute;
        left: 18px;
        top: 14px;
      }
    }
    .select-language {
      & div {
        border-radius: 2px;
        border-color: #c3c3c3;
        box-shadow: none;
        #react-select-2-input {
          padding: 4px;
        }
      }
    }
  }
`
